import React from "react";
import UserAvatar from "../../../../Controls/UserAvatar.mjs";
import "./ChatMessage.css";
import appLib from "../../../../libs/appLib.mjs";

const ChatMessage = class extends React.Component {
	render() {
		const m = this.props.message;
		if (! m?.id) return '';
		return(
			<div
				className={
					"ChatMessage " +
					(m.from === this.props.user ? 'outgoing' : 'incoming') +
					(m.group ? ' group' : ' private')
				}
				id={m.id}
			>
				<div className={"avatarwrap"}>
					<UserAvatar player={m.player} small={true} icon={appLib.player2icon(m.player)} />
				</div>
				<div className={"messagewrap"}>
					<div className={"message"}>
						{ m.body }
					</div>
				</div>
				{ m.group && (
					<div className={"userinfo"}>
						{ appLib.player2name(m.player) }
						{ m.external && " [Telegram]"}
					</div>
				)}
			</div>
		)
	}
}

export default ChatMessage;